// extracted by mini-css-extract-plugin
export default {"base":"styles_base__8r1YX","content":"styles_content__UBytn"};